import api from '~/services/api';
import { producaoSubmit, responseProdutcs } from '../types';

const getProducao = async (
  cod_loja: string | number,
  cod_produto: string | number,
): Promise<any> => {
  const { data } = await api.get<responseProdutcs>(
    `/producao/${cod_loja}/${cod_produto}`,
  );
  return data;
};

const createProducao = async (
  producaoData: producaoSubmit,
): Promise<{ message: string; success: boolean }> => {
  const { data } = await api.post<any>('/producao', producaoData);
  return data;
};

export const producaoServices = {
  getProducao,
  createProducao,
};
